import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import { ControlsPosition } from "@omni/types/components/props/productSlider.props";

import { ProductSliderDefault } from "@/components/Product/ProductSlider/productSlider.default";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useProductPageContext } from "../../context/productPage.context";
import { ProductPageConfig } from "../../productPage.config";

export const RecommendProductsSliderContainer = () => {
    const { t } = useGranite();
    const { product, algoliaRecommendParams, sliders } =
        useProductPageContext();

    if (!sliders?.[ProductSliderSources.AlgoliaRecommend]) {
        return null;
    }

    return (
        <ProductSliderDefault
            title={t("sliders.frequentlyBoughtTogether.title")}
            controlsPosition={ControlsPosition.Default}
            source={ProductSliderSources.AlgoliaRecommend}
            algoliaRecommendParams={algoliaRecommendParams}
            breakpointsConfig={{
                hidden: [],
                layoutSettings: ProductPageConfig.sliders.recommend
            }}
            productTileConfig={{
                amountOfFeatures: 0,
                useInsidePadding: false,
                showButton: false,
                showCategoryLink: false,
                allowInstantAddToCart: false
            }}
            sku={product.sku}
            serverSideProducts={
                sliders?.[ProductSliderSources.AlgoliaRecommend]
            }
        />
    );
};
